import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import Tabs from '../components/Tabs';
import Writing from '../components/Writing';
import Footer from '../components/Footer';
import {
  ABOUT_EXPERIENCE_POSTS,
  ABOUT_EXPERIENCE_SECTION_TITLE,
  POSTS,
} from '../data';
import { TabId } from '../types';
import styles from '../styles/App.module.css';

const HomePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('work');
  const { hash } = useLocation();
  const hashId = hash.replace(/^#/, '');

  useEffect(() => {
    if (!hashId) return;
    if (hashId === 'work') {
      setActiveTab('work');
    } else if (hashId === 'fun-work') {
      setActiveTab('art');
    } else if (hashId === 'contact') {
      setActiveTab('about');
    }
  }, [hashId]);

  useEffect(() => {
    if (!hashId) return;

    const scrollToId = (id: string) => {
      const el = document.getElementById(id);
      if (el) {
        window.requestAnimationFrame(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    };

    if (hashId === 'home') {
      scrollToId('home');
      return;
    }

    if (hashId === 'contact' && activeTab === 'about') {
      const t = window.setTimeout(() => scrollToId('contact'), 0);
      return () => window.clearTimeout(t);
    }

    if (hashId === 'work' && activeTab === 'work') {
      const t = window.setTimeout(() => scrollToId('about'), 0);
      return () => window.clearTimeout(t);
    }

    if (hashId === 'fun-work' && activeTab === 'art') {
      const t = window.setTimeout(() => scrollToId('about'), 0);
      return () => window.clearTimeout(t);
    }
  }, [hashId, activeTab]);

  return (
    <div className={styles.root}>
      <div className={styles.blob1} aria-hidden="true" />
      <div className={styles.blob2} aria-hidden="true" />
      <div className={styles.blob3} aria-hidden="true" />

      <Nav />
      <Hero />
      <Tabs activeTab={activeTab} onTabChange={setActiveTab} />
      {activeTab === 'work' && (
        <Writing posts={POSTS} sectionId="experience" title="design experience" />
      )}
      {activeTab === 'about' && (
        <Writing
          posts={ABOUT_EXPERIENCE_POSTS}
          sectionId="contact"
          title={ABOUT_EXPERIENCE_SECTION_TITLE}
        />
      )}
      <Footer />
    </div>
  );
};

export default HomePage;
